<template>
    <div class="bg p-3 pb-6">
        <div class="form-columns-fit mb-4">
            <div class="columns is-flex-wrap">
                <div class="column is-half is-full-mobile">
                    <verified-date-picker
                        dateType="startDate"
                        :value="dataInicial"
                        :endDate="dataFinal"
                        title="data-inicio"
                        @input="changeStartDate"
                        :showClean="false"
                        :invalid="dataInicial == null"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <verified-date-picker
                        dateType="endDate"
                        :value="dataFinal"
                        :startDate="dataInicial"
                        title="data-fim"
                        @input="changeEndDate"
                        :showClean="false"
                        :invalid="dataFinal == null"
                    />
                </div>
                
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="cliente-contrato"
                        :value="clienteSelected"
                        :options="clienteList"
                        :loading="clienteLoading"
                        @search="carregarClientes"
                        @input="updateCliente"
                        label="rsocial"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="lps"
                        :value="lpsSelected"
                        :options="lpsList"
                        :loading="lpsLoading"
                        @search="carregarLps"
                        @input="updateLps"
                        label="nome"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>

                <div class="column is-half is-full-mobile">
                    <v-input
                        :id="1"
                        ref="diasSemVisitaInput"
                        v-model="diasSemVisita"
                        @input="updateDiasSemVisita"
                        placeholder="placeholder-preencha"
                        :maxlength="10"
                        title="dias-sem-visita"
                        :disabled="nuncaVisitado"
                        validchars="0123456789"
                        tooltipLabel="tooltip-filtro-dias-sem-visita"
                    />
                </div>

                <div class="column is-half is-full-mobile">
                    <div>
                        <label>{{ $t('nunca-visitado') }}</label>
                        <b-tooltip 
                            type="is-dark"
                            multilined
                            :label="$t('tooltip-nunca-visitado')"
                            class="ml-1 tooltip-label"
                        >
                        <b-icon icon="information" size="is-small"/>
                        </b-tooltip>
                    </div>
                    <b-switch
                        v-model="nuncaVisitado"
                        @input="updateNuncaVisitado"
                        size="is-medium"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isNull } from '@/functions/Util';

export default {
    props: {
        filtersReset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dataInicial: new Date(this.$moment().subtract(30, 'days')),
            dataFinal: new Date(),
            clienteList: [],
            clienteSelected: [],
            clienteLoading: false,
            lpsList: [],
            lpsSelected: [],
            lpsLoading: false,
            lpsComRotaList: [],
            cidadeList: [],
            cidadeSelected: [],
            cidadeLoading: false,
            tipoServicoList: [],
            tipoServicoSelected: [],
            tipoServicoLoading: false,
            cargoList: [],
            cargoSelected: [],
            cargoLoading: false,
            agrupaPorLps: false,
            diasSemVisita: null,
            nuncaVisitado: false,
            nuncaVisitadoSelected: false,
            nuncaVisitadoSelect: [
                { label: 'sim', id: 1 },
                { label: 'nao', id: 0 }
            ],
        }
    },
    watch: {
        filtersReset(val) {
            if (val) this.clearFilter();
        },
    },
    methods: {
        changeStartDate(date) {
            if (date.getTime() != this.dataInicial.getTime()) {
                this.dataInicial = date;
                if (!this.isNull(this.dataInicial)) {
                    this.$emit('update-filtro', {
                        nomeFiltro: 'dataInicial',
                        valor: this.dataInicial,
                    })
                }
            }
        },
        changeEndDate(date) {
            if (date.getTime() != this.dataFinal.getTime()) {
                this.dataFinal = date;
                if (!this.isNull(this.dataFinal)) {
                    this.$emit('update-filtro', {
                        nomeFiltro: 'dataFinal',
                        valor: this.dataFinal,
                    })
                }
            }
        },
        carregarClientes(searchQuery) {
            this.clienteLoading = true;
            this.$axios
                .get(`/promotor/cliente/getcombo.json`, {
                    params: {
                        param: searchQuery,
                        situacao: 2
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[RUPTURA] Erro status ${r.status} ao carregar clientes.`);
                        console.error(`[RUPTURA] Mensagem: ${r.message}`);
                    } else {
                        this.clienteList = response.data.content.map((c) => {
                            return {
                                id: c.idcliente,
                                rsocial: c.rsocial,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.clienteList = [];
                    console.error('[RUPTURA] Erro ao carregar clientes.', e);
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        updateCliente(cliente) {
            this.clienteSelected = cliente;
            this.$emit('update-filtro', {
                nomeFiltro: 'idClienteList',
                valor:
                    this.clienteSelected.length == 0 ? [] : this.clienteSelected.map((c) => c.id),
            })
        },
        carregarLps(searchQuery) {
            this.lpsLoading = true;
            this.$axios
                .get(`/promotor/getcombo/lps.json`, {
                    params: {
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[PRO_LPS_NAO_VISITA] Erro status ${r.status} ao carregar lps.`);
                        console.error(`[PRO_LPS_NAO_VISITA] Mensagem: ${r.message}`);
                    } else {
                        this.lpsList = response.data.content.map((l) => {
                            return {
                                id: l.idlps,
                                nome: l.nome,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.lpsList = [];
                    console.error('[PRO_LPS_NAO_VISITA] Erro ao carregar lps.', e);
                })
                .finally((_) => {
                    this.lpsLoading = false;
                });
        },
        updateLps(lps) {
            this.lpsSelected = lps;
            this.$emit('update-filtro', {
                nomeFiltro: 'idLpsList',
                valor:
                    this.lpsSelected.length == 0 ? [] : this.lpsSelected.map((l) => l.id),
            })
        },
        updateDiasSemVisita(value) {
            this.diasSemVisita = value;
            this.$emit('update-filtro', {
                nomeFiltro: 'diasSemVisita',
                valor: this.diasSemVisita,
            })
        },
        updateNuncaVisitado(val) {
            if (val) {
                this.updateDiasSemVisita(0);
            } else {
                this.diasSemVisita = null;
            }
            this.nuncaVisitado = val;
            this.$emit('update-filtro', {
                nomeFiltro: 'nuncaVisitado',
                valor: this.nuncaVisitado,
            })
        },
        clearFilter() {
            this.dataInicial = new Date(this.$moment().subtract(30, 'days'));
            this.dataFinal = new Date();
            this.idClienteList = [];
            this.idLpsList =[];
            this.lpsComRota = { label: 'todos', id: 0 };
            this.diasSemVisita = null;
            this.nuncaVisitado = false;
        },
    }
}
</script>